

import { FC } from 'react';
import Select from 'react-select';
import { IHasIdentifier } from '../../common';
import { NoOptionsMessage, OptionBox, OptionsBox, OptionsListBox } from './components/OptionsBox';
import { IndicatorSeparator } from './components/IndicatorSeparator';
import { DropdownIndicatorBox } from './components/dropdownIndicatorBox';
import { SelectBoxControl, SelectBoxValueContainer } from './components/selectBoxControl';

export type SelectBoxOption = IHasIdentifier & any;
export interface SelectBoxProps {
    className?: string;
    labelName?: string;
    valueName?: string;
    placeholder?: string;
    isSearch?: boolean;
    options?: SelectBoxOption[];
    value?: SelectBoxOption;
    onChange?: (value: SelectBoxOption) => void;
}
export const SelectBox: FC<SelectBoxProps> = (props) => {
    const { valueName, options, placeholder, isSearch, onChange, value, className } = props;
    const getOptionValue = (option: SelectBoxOption): string => option.identifier;
    const getOptionName = (option: SelectBoxOption): any => option[valueName ?? 'name'];

    return (
        <Select
            className={className}
            value={value}
            classNamePrefix={'bg'}
            placeholder={placeholder ?? 'Choose variant'}
            components={{
                Menu: OptionsBox,
                ValueContainer: SelectBoxValueContainer,
                IndicatorSeparator,
                DropdownIndicator: DropdownIndicatorBox,
                Option: OptionBox,
                MenuList: OptionsListBox,
                Control: SelectBoxControl,
                NoOptionsMessage,
            }}
            isSearchable={isSearch}
            getOptionLabel={getOptionName}
            getOptionValue={getOptionValue}
            options={options ?? []}
            onChange={onChange as any}
        />
    );
};


import { FC } from 'react';
import Select from 'react-select';
import { IHasIdentifier } from '../../common';
import { NoOptionsMessage, OptionBox, OptionsBox, OptionsListBox } from './components/OptionsBox';
import { IndicatorSeparator } from './components/IndicatorSeparator';
import { DropdownIndicatorBox } from './components/dropdownIndicatorBox';
import { SelectBoxControl, SelectBoxValueContainer } from './components/selectBoxControl';

export type SelectBoxOption = IHasIdentifier & any;
export interface SelectBoxProps {
    className?: string;
    labelName?: string;
    valueName?: string;
    placeholder?: string;
    isSearch?: boolean;
    options?: SelectBoxOption[];
    value?: SelectBoxOption;
    onChange?: (value: SelectBoxOption) => void;
}
export const SelectBox: FC<SelectBoxProps> = (props) => {
    const { valueName, options, placeholder, isSearch, onChange, value, className } = props;
    const getOptionValue = (option: SelectBoxOption): string => option.identifier;
    const getOptionName = (option: SelectBoxOption): any => option[valueName ?? 'name'];

    return (
        <Select
            className={className}
            value={value}
            classNamePrefix={'bg'}
            placeholder={placeholder ?? 'Choose variant'}
            components={{
                Menu: OptionsBox,
                ValueContainer: SelectBoxValueContainer,
                IndicatorSeparator,
                DropdownIndicator: DropdownIndicatorBox,
                Option: OptionBox,
                MenuList: OptionsListBox,
                Control: SelectBoxControl,
                NoOptionsMessage,
            }}
            isSearchable={isSearch}
            getOptionLabel={getOptionName}
            getOptionValue={getOptionValue}
            options={options ?? []}
            onChange={onChange as any}
        />
    );
};
